if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

class ProductInfoModal extends HTMLElement {
  constructor() {
    super();

    this.productInfoModal = this.querySelector('.js-product-info-modal');
    this.triggers = this.querySelectorAll('.js-product-info-modal-trigger');

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', this.toggleproductInfoModal.bind(this));
    });
  }

  toggleproductInfoModal() {
    this.productInfoModal.classList.toggle('open');
  }
}

customElements.define('product-info-modal', ProductInfoModal);

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', class SizeGuide extends ProductInfoModal {
    constructor() {
      super();

      this.unit = 'unit-in'
      this.selectedSize = ''
      this.sizeGuideSizes = this.querySelector('.js-size-guide-sizes');
      this.sizeGuideInfoSizes = this.querySelector('.js-size-guide-info-sizes');
      this.sizes = window.productSizes?.measurements;
      this.tabs = this.querySelectorAll('.size-guide__info');
      this.table = this.querySelector('tbody');
      this.tableCells = this.querySelectorAll('td:not(first-child)');

      this.initSizes();

      this.tableCells.forEach((cell) => {
        cell.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
      })

      this.addEventListener('change', this.handleChange.bind(this));
      this.table.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
    }

    initSizes() {
      if (!this.sizes) return;

      this.sizes.map((size, idx) => {
        const input = document.createElement('input');
        const label = document.createElement('label');
        const id = `size-guide-size-${size.size}`
        input.setAttribute('type', 'radio');
        input.setAttribute('id', id);
        input.setAttribute('name', 'size-guide-size');
        input.setAttribute('value', size.size);
        label.setAttribute('for', id);
        label.className = 'size-guide__label eyebrow';
        label.innerText = size.size;

        if (idx === 0) {
          input.setAttribute('checked', true);
          this.selectedSize = size.size;
        }

        this.sizeGuideSizes.appendChild(input);
        this.sizeGuideSizes.appendChild(label);
      })

      this.setSizeGuideSizes();
    }

    handleChange({ target }) {
      if (target.closest('.size-guide__tabs.sizing')) {
        this.tabs?.forEach((tab) => tab.classList.remove('active'))
        this.querySelector(`.${target.id}`).classList.add('active');
      } else if (target.closest('.size-guide__tabs.units')) {
        this.handleUnitChange({ target });
      } else if (target.closest('.size-guide__tabs.sizes')) {
        this.selectedSize = target.value
        this.setSizeGuideSizes();
      }
    }

    handleMouseEnter({ currentTarget }) {
      const tbodyEl = currentTarget.closest('tbody')
      const parent = currentTarget.parentNode;
      const columnIndex = Array.prototype.indexOf.call(parent.children, currentTarget);
      const rowIndex = Array.prototype.indexOf.call(parent.parentNode.children, parent);

      tbodyEl.className = '';
      tbodyEl.classList.add(`highlight-${columnIndex + 1}-${rowIndex + 1}`)
    }

    handleMouseLeave() {
      this.table.className = '';
    }

    handleUnitChange({ target }) {
      this.unit = target.value;
      this.setSizeGuideSizes();
    }

    appendSizes(s) {
      const sArr = s.split(',');

      this.sizeGuideInfoSizes.innerHTML = '';

      sArr.forEach((mes) => {
        const p = document.createElement('p');

        p.innerText = mes;
        this.sizeGuideInfoSizes.appendChild(p);
      })
    }

    setSizeGuideSizes() {
      const selected = this.sizes.find(({ size }) => size === this.selectedSize);

      if (this.unit === 'unit-in') {
        this.appendSizes(selected.unit.in);
      } else if (this.unit === 'unit-cm') {
        this.appendSizes(selected.unit.cm);
      }
    }
  })
}
